<template>
  <div class="column_center_start body">
  </div>
</template>

<script>
import auth from "@/utils/auth.utils"
export default {
  computed: {
    isLogin() {
      return this.$store.getters["userData/isLogin"];
    },
  },
  data() {
    return {};
  },
  beforeMount() {
    this.redirect();
  },
  methods: {
    async redirect() {
      try {
        // 取得 query 參數
        const queryData = this.$route.query;
        console.log("query data", queryData);
        
        // 先檢查：如果沒有任何參數，重導向到官網（不管登入狀態）
        if (!queryData || Object.keys(queryData).length === 0) {
          console.log("no query data, redirect to external page");
          window.location.href = "https://www.okshop.tw/";
          return;
        }
        
        // 再檢查是否有 LINE 登入資料
        const lineLoginData = this.$store.state.line.lineLoginData
        const accessToken = this.$store.getters['line/accessToken']
        
        if (!lineLoginData || !accessToken) {
          console.log("no access token, stay at home page");
          return;
        } else {
          // 有登入資料，處理 state 參數重導向
          let stateData = {}
          if (queryData.state) {
            stateData = {...JSON.parse(queryData.state)};
            console.log("queryData contains stateData", stateData);
          }
          // /store-list 專用導向（無 store code）
          if (stateData.page === 'store-list') {
            this.$router.push({ path: '/store-list' });
            return;
          }
          if (stateData.data) {
            const data = stateData.data;
            const dataKeys = Object.keys(data);
            let path = `/${stateData.store}`;
            dataKeys.forEach((key) => {
              path += `/${data[key]}`;
            });
            console.log("contain callback data", path);
            this.$router.push({
              path: path,
            });
          } else {
            this.$router.push({
              path: `/${stateData.store}`,
            });
          }
        }
      } catch (error) {
        // 發生錯誤時重導向到官網
        console.error('redirect error', error);
        auth.logout();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.body {
  background-color: #eeeeee;
  height: 100vh;
  width: 100vw;

  button {
    margin-top: 10px;
  }
}
</style>
